import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { wacToken } from "@/libraries/design/foundations";

import { getShareableUrl } from "./personalization-url-utils";

import type { PersonalizationUserSegmentValues } from "./personalization-controls";

interface ShareableUrlDisplayProps {
    values: PersonalizationUserSegmentValues;
    compositionSlug?: string | null;
}

export const ShareableUrlDisplay = ({
    values,
    compositionSlug
}: ShareableUrlDisplayProps) => {
    const fullUrl = getShareableUrl(values, compositionSlug);

    return (
        <div
            css={css({
                display: "flex",
                flexDirection: "column",
                gap: token("space.075"),
                padding: token("space.100"),
                backgroundColor: wacToken("color.neutral.light100"),
                borderRadius: "4px",
                border: `1px solid ${wacToken("color.neutral.dark700")}`
            })}
        >
            <span
                css={css({
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    color: wacToken("color.neutral.dark200")
                })}
            >
                Shareable URL
            </span>
            <input
                type="text"
                readOnly
                value={fullUrl || "(no overrides set)"}
                title={fullUrl || undefined}
                onFocus={(e) => e.target.select()}
                css={css({
                    fontSize: "0.65rem",
                    fontFamily: "monospace",
                    width: "100%",
                    padding: `${token("space.025")} ${token("space.050")}`,
                    border: `1px solid ${wacToken("color.neutral.dark700")}`,
                    borderRadius: "4px",
                    backgroundColor: fullUrl
                        ? wacToken("color.neutral.light0")
                        : wacToken("color.neutral.light200"),
                    color: fullUrl
                        ? wacToken("color.neutral.dark100")
                        : wacToken("color.neutral.dark500"),
                    cursor: fullUrl ? "text" : "default",
                    boxSizing: "border-box"
                })}
            />
        </div>
    );
};
